import { I18nService as S } from "@perxis-auto/shared";
import { StageEntityId as e } from "@perxis-auto/trade-in-sdk/types";
import { APP as n } from "./app.js";
const _ = {
  [e.STAGE_1]: 1,
  [e.STAGE_2]: 1,
  [e.STAGE_3]: 2,
  [e.STAGE_4]: 2,
  [e.SUCCESS]: 3
}, a = (E) => {
  const { t } = S.getInstance().i18n;
  return E === e.ERROR ? "" : {
    [e.STAGE_1]: t("stageHeader.title.first", { ns: n.name }),
    [e.STAGE_2]: t("stageHeader.title.second", { ns: n.name }),
    [e.STAGE_3]: t("stageHeader.title.third", { ns: n.name }),
    [e.STAGE_4]: t("stageHeader.title.fourth", { ns: n.name }),
    [e.SUCCESS]: t("stageHeader.title.success", { ns: n.name })
  }[E];
}, i = 3;
export {
  a as GET_STAGE_TITLE_MAP,
  i as MAX_STAGE_NUMBER,
  _ as STAGE_NUMBER_MAP
};
